// --- React
import React, { useState } from 'react';
// --- External UI Libraries
import Footer from '@dtci/spellbook/Footer';
// --- Components
import { ReleaseNotesModal } from './ReleaseNotesModal';
// --- Config
import { APP_VERSION } from '../../config/releaseNotes.js';
// --- Styles
import './styles.scss';

/**
 * AppFooter Component
 *
 * Renders the global footer with default links and a clickable version
 * label that opens the release notes modal.
 */
export function AppFooter() {
    const [isReleaseNotesOpen, setIsReleaseNotesOpen] = useState(false);

    return (
        <>
            <Footer>
                <div className="app-footer__content">
                    <div>
                        Copyright © DEE Technology - All Rights Reserved |{' '}
                        <span className="sb-footer__terms-privacy">
                            <a
                                href="http://disneytermsofuse.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Terms of Use
                            </a>{' '}
                            |{' '}
                            <a
                                href="https://disneyprivacycenter.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Privacy Policy
                            </a>{' '}
                            |{' '}
                        </span>
                        <a
                            href="https://support.twdc.technology"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Support
                        </a>
                    </div>
                    <button
                        type="button"
                        className="app-footer__version"
                        onClick={() => setIsReleaseNotesOpen(true)}
                        aria-label={`View release notes for ${APP_VERSION}`}
                    >
                        {APP_VERSION}
                    </button>
                </div>
            </Footer>
            <ReleaseNotesModal
                isOpen={isReleaseNotesOpen}
                onClose={() => setIsReleaseNotesOpen(false)}
            />
        </>
    );
}
